import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/banquanly')));

// utilities routing
const DanhSachDiemDanhHS = Loadable(lazy(() => import('views/diemdanh/DanhSachDiemDanhHS')));
const DiemdanhHS = Loadable(lazy(() => import('views/diemdanh/DiemDanhHS')));
const DetailDiemDanhHS = Loadable(lazy(() => import('views/diemdanh/DetailDiemDanhHS')));
const KetQuaTuTapHS = Loadable(lazy(() => import('views/banquanly/KetQuaTuTap')));
const KetQuaTuTapHSDetail = Loadable(lazy(() => import('views/banquanly/KetQuaTuTapDetails')));
const KetQuaTuHocNhom = Loadable(lazy(() => import('views/banquanly/KetQuaTuHocNhom')));
const ThongTinHanhSinh = Loadable(lazy(() => import('views/banquanly/ThongTinHanhSinh')));
const ThongTinHanhSinhDetails = Loadable(lazy(() => import('views/banquanly/ThongTinHanhSinhDetails')));
const DiemTuTapHocTap = Loadable(lazy(() => import('views/banquanly/DiemTuTapHocTap')));
const DiemTuTapHocTapDetails = Loadable(lazy(() => import('views/banquanly/DiemTuTapHocTapDetails')));
const DanhSachDangKyLuuTru = Loadable(lazy(() => import('views/banquanly/DanhSachDangKyLuuTru')));
const DanhSachKeHoachThucTap = Loadable(lazy(() => import('views/banquanly/DanhSachKeHoachThucTap')));
// Trang của hạnh sinh, nhưng ban quản lý vẫn cần mở được bằng link: không khai báo ở đây thì
// useRoutes không khớp route nào và trả về null - người dùng nhìn thấy TRANG TRẮNG, không một
// dòng chữ nào giải thích.
const KeHoachThucTapHS = Loadable(lazy(() => import('views/hanhsinh/KeHoachThucTap')));

// ==============================|| MAIN ROUTING ||============================== //

const BQLMainRoutes = (isLoggedIn) => {
    return {
        path: '/',
        element: isLoggedIn ? <MainLayout /> : <Navigate to="/login" />,
        children: [
            {
                path: '/',
                element: <DashboardDefault />
            },
            {
                path: '/',
                children: [
                    {
                        path: 'danh-sach-hanh-sinh-diem-danh',
                        element: <DanhSachDiemDanhHS />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'diem-danh-hanh-sinh',
                        element: <DiemdanhHS />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'diem-danh-hanh-sinh-detai',
                        element: <DetailDiemDanhHS />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-ket-qua-tu-tap',
                        element: <KetQuaTuTapHS />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-ket-qua-tu-tap/:maHs/:thang',
                        element: <KetQuaTuTapHSDetail />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-ket-qua-tu-hoc',
                        element: <KetQuaTuHocNhom />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-thong-tin-hanh-sinh',
                        element: <ThongTinHanhSinh />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-thong-tin-hanh-sinh/:maHs',
                        element: <ThongTinHanhSinhDetails />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-diem-kiem-tra',
                        element: <DiemTuTapHocTap />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-diem-kiem-tra/:maHs',
                        element: <DiemTuTapHocTapDetails />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'bql-dang-ky-luu-tru',
                        element: <DanhSachDangKyLuuTru />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'ban-quan-ly-ke-hoach-thuc-tap',
                        element: <DanhSachKeHoachThucTap />
                    }
                ]
            },
            {
                path: '/',
                children: [
                    {
                        path: 'hanh-sinh-ke-hoach-thuc-tap',
                        element: <KeHoachThucTapHS />
                    }
                ]
            }
        ]
    };
};

export default BQLMainRoutes;
